module.exports = __webpack_public_path__ + "img/coins_2.51739a22.png";